import React, { useEffect, } from "react";
import { useEventsContext } from "../../../../context/eventsContext";
import EventPreview from "../EventPreview";
import { loadPastEvents } from "../../../../context/eventsContext/actions";

interface IPastEventsProps {
  className?: string;
  past_events?: any[];
}

const PastEvents = ({ className, past_events }: IPastEventsProps) => {
  const {
    dispatch: eventsDispatch,
  } = useEventsContext();

  useEffect(() => {
    loadPastEvents(eventsDispatch, past_events);
  }, [eventsDispatch, past_events]);

  return (
    <div className={`${ className }`}>
      <h1 className="text-xl md:text-3xl font-light w-full leading-1 pb-4">
        Past Events
      </h1>
        <div className="grid grid-cols-12 gap-4 pb-16">
          {
            past_events &&
            past_events.map((event) => (
              <EventPreview 
                className="col-span-12"
                event={event}
                key={event.id}
              />
            ))
          }
        </div>
      
    </div>
  )
}

export default PastEvents;